import { CompanyUser } from "src/models/companyUser";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CoeWorkMagerEntityModel = createEntityModel<CompanyUser>();
